<template>
  <v-flex xs12 row>

    <v-card v-if="dispatch">
      <v-card-title>
        <v-flex xs12 class="text-xs-center">
          <img src="../assets/images/eurotech-logo.jpg">
          <div class="headline text-uppercase">Stock Dispatch</div>
        </v-flex>
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md>
          
          <v-layout wrap>

            <v-flex xs6>
              <div class="subheading text-uppercase">
                <span>Dispatch No. : </span>
                <span>{{dispatch.id}}</span>
              </div>

            </v-flex>

            <v-flex xs6 class="text-xs-right">
              <div class="body-2 py-2">
                <span>Date: </span>
                <span>{{dispatch.date}}</span>
              </div>
            </v-flex>

          </v-layout>

          <v-layout wrap>

            <v-flex xs6>
              <div class="caption font-weight-light">Dispatch From</div>
              <div class="body-1">{{dispatch.factory_name}}</div>              
            </v-flex>

            <v-flex xs6 class="text-xs-right">
              <div class="caption font-weight-light">Dispatch To</div>
              <div class="body-1">{{dispatch.warehouse_name}}</div>              
            </v-flex>

          </v-layout>

        </v-container>
        <v-divider></v-divider>
        <v-container>
          <v-layout wrap>
            <v-flex xs12>
              <div>
                <div class="v-table__overflow">
                  <table class="v-datatable v-table">
                    <thead>
                      <tr>
                        <th role="columnheader" scope="col" class="column text-xs-left">
                          <span>Item Code</span>
                        </th>
                        <th role="columnheader" scope="col" class="column text-xs-left">
                          <span>Item Name</span>
                        </th>
                        <th role="columnheader" scope="col" class="column text-xs-left">
                          <span>Unit</span>
                        </th>
                        <th role="columnheader" scope="col" class="column text-xs-right">
                          <span>QTY</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody v-if="dispatch.items && dispatch.items.length > 0">
                      <tr is="dispatch-item" v-for="(item, index) in dispatch.items" v-bind:item="item" v-bind:index="index"  viewMode="true"></tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="8">No Items Added</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

    </v-card>
    
  </v-flex>
</template>

<script>
  
  import StockDispatchItem from './StockDispatchItem'

  export default {
    name: 'PrintDispatch',
    data () {
      return {
      	title: "Dispatch",
      	processing: false,
        dispatch: null,
        factories: [],
        warehouses: []
      }
    },
    created () {

    },
    methods: {

      loadStockDispatch (dispatchId) {
        this.processing = true
        this.axios.get(this.config.apis.getStockDispatch.replace(":id", dispatchId))
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.dispatch = response.data.data
              setTimeout(window.print, 200)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      setPageTitle (title) {
        document.title = title
      }

    },
    mounted () {
      
      if (this.$route.params.id) {
        
        this.loadStockDispatch(this.$route.params.id)
        
        let date = new Date()
        
        this.setPageTitle(`${this.$route.params.id}-${date.getTime()}`)

      }
      
    },

    computed: {

    },

    watch: {

      '$route' (to, from) {
        // react to route changes...
        if (to !== from && to.params.id) {
          this.loadStockDispatch(to.params.id)
          let date = new Date()
          this.setPageTitle(`${this.$route.params.id}-${date.getTime()}`)
        }

      }

    },
    
    components: {
      'dispatch-item': StockDispatchItem,
    }

  }
</script>
